export default __webpack_public_path__ + "static/media/customer_list_1.4b70a232.png";